import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const BoardWidth = (props) => {
  const name = 'board_width';
  const {
    parameters,
    errorMessage,
    label,
    inputId,
    required,
    onChangeParameter,
    placeholder,
    groupName,
    tooltip,
    className,
    inputClassName,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      placeholder={placeholder}
      groupName={groupName}
      onChange={onChange}
      tooltip={tooltip}
      className={className}
      inputClassName={inputClassName}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

BoardWidth.defaultProps = {
  label: Spree.translations.parameters.board_width,
  tooltip: Spree.helpForParameters.board_width,
  placeholder: 'width',
};

export default BoardWidth;
